
export default class JobsList {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.jobs-list'), el => {
			new JobsList(el);
		});
	}

	constructor(element) {
		this.element = element;
		this.showAll = false;

		if (this.element.classList.contains('jobs-list--no-results')) {
			return;
		}

		/*
		if(document.getElementById('location').value === 'all') {
			// we are on the global page, preselect from local storage
			const country = window.localStorage && localStorage.getItem('career-country');
			if(country) {
				document.getElementById('location').value = country;
			}
		}
		*/

		this.updateFiltering();

		const locationSelect = document.getElementById('jobs-list__location');
		if(locationSelect) locationSelect.addEventListener('change', () => { this.filterAndShowAll()});
		document.getElementById('jobs-list__time').addEventListener('change', () => { this.filterAndShowAll()});
		document.getElementById('jobs-list__search').addEventListener('keyup', () => { this.filterAndShowAll()});
		document.getElementById('jobs-list__search').addEventListener('keydown', (event) => { return event.keyCode !== 13 } )

		const button = this.element.querySelector('.jobs-list__show-all-button');
		if (button) {
			button.addEventListener('click', () => this.filterAndShowAll());
		}
	}

	removeShowAllButton() {
		this.showAll = true;
		const button = this.element.querySelector('.jobs-list__show-all-button');
		if (button) {
			button.remove();
		}
	}

	filterAndShowAll() {
		this.removeShowAllButton();
		this.updateFiltering();
	}

	updateFiltering() {
		const locationSelect = document.getElementById('jobs-list__location');
		const location = locationSelect ? locationSelect.value : 'all';
		const time = document.getElementById('jobs-list__time').value;
		const search = document.getElementById('jobs-list__search').value;

		/*
		// set the cookie
		if(location!=='all' && window.localStorage) {
			localStorage.setItem('career-country', location);
		}
		 */

		const showAll = this.showAll;
		let count = 0;
		Array.prototype.forEach.call(this.element.querySelectorAll('.teaser-object'), el => {
			let matches = (location === 'all' || el.dataset.location.indexOf(location) > -1) && (time === 'all' || el.dataset.time === time);
			matches = matches && (!search || el.dataset.search.toLowerCase().indexOf(search.trim().toLowerCase()) !== -1);
			el.classList[(matches && (showAll || count<9)) ? 'remove' : 'add']('jobs-list__item--hidden');
			count += matches ? 1 : 0;
		});
		document.querySelector('.jobs-list-count').innerHTML = count;

		if(count === 0) {
			this.removeShowAllButton();
		}
	}
}
